import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { Col } from "components/bootstrap";
const ErrorFallback = ({ error, title }) => {
  const { t } = useTranslation("pages");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h2", null, title), /* @__PURE__ */ React.createElement("p", null, t("configlet.error")), /* @__PURE__ */ React.createElement("pre", null, error.message));
};
const Boundary = ({ children, title }) => /* @__PURE__ */ React.createElement(ErrorBoundary, { FallbackComponent: (props) => /* @__PURE__ */ React.createElement(ErrorFallback, { title, ...props }) }, children);
const ConfigletContainer = ({ children, title }) => /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Boundary, { title }, children));
export default ConfigletContainer;
